import { render, staticRenderFns } from "./BasicProfile.vue?vue&type=template&id=e993cbbc"
import script from "./BasicProfile.vue?vue&type=script&lang=js"
export * from "./BasicProfile.vue?vue&type=script&lang=js"
import style0 from "./BasicProfile.vue?vue&type=style&index=0&id=e993cbbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports